import { useHttpClient } from '@hakimo-ui/hakimo/util';

export function useSituationLabels(locationId?: string) {
  const httpClient = useHttpClient();

  return (query: string) => {
    const params = new URLSearchParams({ query });
    if (locationId) {
      params.set('location_id', locationId);
    }
    const url = `/v2/orm/situations?${params.toString()}`;

    return httpClient<string[]>(url, {
      responseModifier: async (response) => {
        const respJson = await response.json();
        return (respJson.payload?.items || []).map((item: any) => item.label);
      },
    });
  };
}

export default useSituationLabels;
